/**
 * Dual-submit theme newsletter forms to Klaviyo General Subscribers (UVbTyE).
 * Homepage signups set signup_source=homepage and trigger the
 * "Homepage Welcome" flow (from noreply@riift.com).
 * Every successful step-1 / single-step submit also logs
 * "Submitted Newsletter Form" so repeat signups show on the profile
 * (Klaviyo will not fire another Subscribed to List for existing subscribers).
 * Footer/single-step still dual-submits to Shopify.
 * Coming-soon multi-step: subscribe first (existing emails are fine),
 * then optional extras. Step 2 is not shown until Klaviyo confirms step 1.
 * After step 1, forms can stay on-page or redirect to /pages/signup.
 * Native POST must never navigate the page (password/coming-soon drops
 * Liquid form.posted_successfully? on reload).
 */
(function () {
  var COMPANY_ID = 'RWhL34';
  var LIST_ID = 'UVbTyE';
  var REVISION = '2025-10-15';
  var NEWSLETTER_BUILD = '2026-09-03-step-test-preview';
  var TIMEOUT_MS = 800;
  var SUCCESS_KEY = 'riift-newsletter-success';
  var STEP_KEY = 'riift-newsletter-step';
  var PENDING_KEY = 'riift-newsletter-pending';
  var DEFAULT_STEP2_URL = '/pages/signup';
  var SINK_NAME = 'riift_newsletter_sink';
  var SUBSCRIBE_ENDPOINT =
    'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID;
  var PROFILE_ENDPOINT =
    'https://a.klaviyo.com/client/profiles/?company_id=' + COMPANY_ID;
  var EVENT_ENDPOINT =
    'https://a.klaviyo.com/client/events/?company_id=' + COMPANY_ID;

  // [iso, name, dial] — dial used to build E.164 when user enters a national number
  var COUNTRIES = [
    ['AU', 'Australia', '61'],
    ['NZ', 'New Zealand', '64'],
    ['US', 'United States', '1'],
    ['CA', 'Canada', '1'],
    ['GB', 'United Kingdom', '44'],
    ['ZA', 'South Africa', '27'],
    ['FR', 'France', '33'],
    ['ES', 'Spain', '34'],
    ['PT', 'Portugal', '351'],
    ['IT', 'Italy', '39'],
    ['DE', 'Germany', '49'],
    ['NL', 'Netherlands', '31'],
    ['BE', 'Belgium', '32'],
    ['IE', 'Ireland', '353'],
    ['JP', 'Japan', '81'],
    ['ID', 'Indonesia', '62'],
    ['FJ', 'Fiji', '679'],
    ['PF', 'French Polynesia', '689'],
    ['NC', 'New Caledonia', '687'],
    ['BR', 'Brazil', '55'],
    ['MX', 'Mexico', '52'],
    ['AR', 'Argentina', '54'],
    ['CL', 'Chile', '56'],
    ['PE', 'Peru', '51'],
    ['CO', 'Colombia', '57'],
    ['CR', 'Costa Rica', '506'],
    ['PA', 'Panama', '507'],
    ['PH', 'Philippines', '63'],
    ['TH', 'Thailand', '66'],
    ['VN', 'Vietnam', '84'],
    ['MY', 'Malaysia', '60'],
    ['SG', 'Singapore', '65'],
    ['HK', 'Hong Kong', '852'],
    ['TW', 'Taiwan', '886'],
    ['KR', 'South Korea', '82'],
    ['CN', 'China', '86'],
    ['IN', 'India', '91'],
    ['AE', 'United Arab Emirates', '971'],
    ['IL', 'Israel', '972'],
    ['TR', 'Turkey', '90'],
    ['GR', 'Greece', '30'],
    ['SE', 'Sweden', '46'],
    ['NO', 'Norway', '47'],
    ['DK', 'Denmark', '45'],
    ['FI', 'Finland', '358'],
    ['CH', 'Switzerland', '41'],
    ['AT', 'Austria', '43'],
    ['PL', 'Poland', '48'],
    ['CZ', 'Czech Republic', '420'],
    ['MA', 'Morocco', '212'],
    ['EG', 'Egypt', '20'],
    ['KE', 'Kenya', '254'],
    ['MU', 'Mauritius', '230'],
    ['SC', 'Seychelles', '248'],
    ['MV', 'Maldives', '960'],
    ['LK', 'Sri Lanka', '94'],
    ['TO', 'Tonga', '676'],
    ['WS', 'Samoa', '685'],
    ['PG', 'Papua New Guinea', '675'],
    ['SB', 'Solomon Islands', '677'],
    ['VU', 'Vanuatu', '678'],
    ['CK', 'Cook Islands', '682'],
    ['AS', 'American Samoa', '1'],
    ['GU', 'Guam', '1'],
    ['PR', 'Puerto Rico', '1'],
    ['RU', 'Russia', '7'],
    ['UA', 'Ukraine', '380'],
    ['HR', 'Croatia', '385'],
    ['SI', 'Slovenia', '386'],
    ['HU', 'Hungary', '36'],
    ['RO', 'Romania', '40'],
    ['BG', 'Bulgaria', '359'],
    ['IS', 'Iceland', '354'],
    ['MT', 'Malta', '356'],
    ['CY', 'Cyprus', '357'],
    ['LU', 'Luxembourg', '352'],
    ['MC', 'Monaco', '377'],
    ['AD', 'Andorra', '376'],
    ['SM', 'San Marino', '378'],
    ['VA', 'Vatican City', '379'],
    ['LI', 'Liechtenstein', '423'],
    ['UY', 'Uruguay', '598'],
    ['EC', 'Ecuador', '593'],
    ['BO', 'Bolivia', '591'],
    ['PY', 'Paraguay', '595'],
    ['VE', 'Venezuela', '58'],
    ['DO', 'Dominican Republic', '1'],
    ['JM', 'Jamaica', '1'],
    ['TT', 'Trinidad and Tobago', '1'],
    ['BS', 'Bahamas', '1'],
    ['BB', 'Barbados', '1'],
    ['BZ', 'Belize', '501'],
    ['GT', 'Guatemala', '502'],
    ['HN', 'Honduras', '504'],
    ['SV', 'El Salvador', '503'],
    ['NI', 'Nicaragua', '505'],
    ['CU', 'Cuba', '53'],
    ['AW', 'Aruba', '297'],
    ['CW', 'Curaçao', '599'],
    ['SA', 'Saudi Arabia', '966'],
    ['QA', 'Qatar', '974'],
    ['BH', 'Bahrain', '973'],
    ['KW', 'Kuwait', '965'],
    ['OM', 'Oman', '968'],
    ['JO', 'Jordan', '962'],
    ['LB', 'Lebanon', '961'],
    ['PK', 'Pakistan', '92'],
    ['BD', 'Bangladesh', '880'],
    ['NP', 'Nepal', '977'],
    ['MM', 'Myanmar', '95'],
    ['KH', 'Cambodia', '855'],
    ['LA', 'Laos', '856'],
    ['BN', 'Brunei', '673'],
    ['MO', 'Macau', '853'],
    ['MN', 'Mongolia', '976'],
    ['KZ', 'Kazakhstan', '7'],
    ['UZ', 'Uzbekistan', '998'],
    ['NG', 'Nigeria', '234'],
    ['GH', 'Ghana', '233'],
    ['TZ', 'Tanzania', '255'],
    ['UG', 'Uganda', '256'],
    ['RW', 'Rwanda', '250'],
    ['ET', 'Ethiopia', '251'],
    ['MZ', 'Mozambique', '258'],
    ['AO', 'Angola', '244'],
    ['NA', 'Namibia', '264'],
    ['BW', 'Botswana', '267'],
    ['ZW', 'Zimbabwe', '263'],
    ['RE', 'Réunion', '262'],
    ['GP', 'Guadeloupe', '590'],
    ['MQ', 'Martinique', '596'],
    ['GF', 'French Guiana', '594'],
    ['YT', 'Mayotte', '262'],
    ['PM', 'Saint Pierre and Miquelon', '508']
  ];

  function ensureSink() {
    var existing = document.querySelector('iframe[name="' + SINK_NAME + '"]');
    if (existing) return existing;
    if (!document.body) return null;
    var iframe = document.createElement('iframe');
    iframe.setAttribute('name', SINK_NAME);
    iframe.setAttribute('title', 'Newsletter submit');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.tabIndex = -1;
    iframe.style.cssText =
      'position:absolute;width:0;height:0;border:0;clip:rect(0,0,0,0);';
    document.body.appendChild(iframe);
    return iframe;
  }

  function isMultiStep(form) {
    return (
      form.getAttribute('data-multi-step') === 'true' ||
      form.classList.contains('js-klaviyo-newsletter--multi')
    );
  }

  function getEmail(form) {
    var input = form.querySelector('input[type="email"][name="contact[email]"]');
    if (!input) return '';
    return (input.value || '').trim();
  }

  function getTextValue(form, selector) {
    var input = form.querySelector(selector);
    if (!input) return '';
    return (input.value || '').trim();
  }

  function getCheckedValues(form, selector) {
    var nodes = form.querySelectorAll(selector + ':checked');
    var values = [];
    for (var i = 0; i < nodes.length; i++) {
      values.push(nodes[i].value);
    }
    return values;
  }

  function getSource(form) {
    var context = form.querySelector('input[name="contact[context]"]');
    if (context && context.value) return context.value;
    return 'newsletter';
  }

  function getStep2Destination(form) {
    return form.getAttribute('data-step2-destination') === 'dedicated_page'
      ? 'dedicated_page'
      : 'on_page';
  }

  function getStep2Url(form) {
    return form.getAttribute('data-step2-url') || DEFAULT_STEP2_URL;
  }

  function needsAddress(youAre) {
    if (!youAre || !youAre.length) return false;
    return (
      youAre.indexOf('Shaper') !== -1 ||
      youAre.indexOf('Dealer') !== -1 ||
      youAre.indexOf('School / Demo Centre') !== -1
    );
  }

  function isShaper(youAre) {
    return !!youAre && youAre.indexOf('Shaper') !== -1;
  }

  function setHidden(el, hidden) {
    if (!el) return;
    el.hidden = hidden;
    if (hidden) {
      el.setAttribute('hidden', '');
    } else {
      el.removeAttribute('hidden');
    }
  }

  function updateStep2Intro(form) {
    var intro = form.querySelector('[data-newsletter-step2-intro]');
    if (!intro) return;
    var youAre = getCheckedValues(form, '[data-newsletter-you-are]');
    var rider =
      intro.getAttribute('data-intro-rider') ||
      'Please tell us a bit more about you, if you have a minute.';
    var trade =
      intro.getAttribute('data-intro-trade') ||
      'Please provide us with a few more details, if you have a minute.';
    intro.textContent = needsAddress(youAre) ? trade : rider;
  }

  function toggleConditionalFields(form) {
    var youAre = getCheckedValues(form, '[data-newsletter-you-are]');
    setHidden(
      form.querySelector('[data-newsletter-address-fields]'),
      !needsAddress(youAre)
    );
    setHidden(form.querySelector('[data-newsletter-shaper-field]'), isShaper(youAre));
    updateStep2Intro(form);
  }

  function updateMultiselectLabel(form) {
    var label = form.querySelector('[data-newsletter-multiselect-label]');
    if (!label) return;
    var youAre = getCheckedValues(form, '[data-newsletter-you-are]');
    if (!youAre.length) {
      label.textContent = 'Select all that apply';
      label.setAttribute('data-empty', 'true');
      return;
    }
    label.textContent = youAre.join(', ');
    label.removeAttribute('data-empty');
  }

  function setMultiselectOpen(form, open) {
    var root = form.querySelector('[data-newsletter-multiselect]');
    if (!root) return;
    var toggle = root.querySelector('[data-newsletter-multiselect-toggle]');
    var panel = root.querySelector('[data-newsletter-multiselect-panel]');
    if (!toggle || !panel) return;
    setHidden(panel, !open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      root.classList.add('is-open');
    } else {
      root.classList.remove('is-open');
    }
  }

  function bindMultiselect(form) {
    var root = form.querySelector('[data-newsletter-multiselect]');
    if (!root || root.getAttribute('data-newsletter-multiselect-bound') === 'true') {
      return;
    }
    root.setAttribute('data-newsletter-multiselect-bound', 'true');
    var boxes = form.querySelectorAll('[data-newsletter-you-are]');
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].checked = false;
    }
    updateMultiselectLabel(form);
    toggleConditionalFields(form);
    var toggle = root.querySelector('[data-newsletter-multiselect-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      setMultiselectOpen(form, toggle.getAttribute('aria-expanded') !== 'true');
    });
  }

  function closeOpenMultiselects(exceptRoot) {
    var openRoots = document.querySelectorAll('[data-newsletter-multiselect].is-open');
    for (var i = 0; i < openRoots.length; i++) {
      if (exceptRoot && openRoots[i] === exceptRoot) continue;
      var form = openRoots[i].closest('form');
      if (form) setMultiselectOpen(form, false);
    }
  }

  function applyYouAre(form, youAre) {
    if (!youAre) return;
    var nodes = form.querySelectorAll('[data-newsletter-you-are]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].checked = youAre.indexOf(nodes[i].value) !== -1;
    }
    updateMultiselectLabel(form);
  }

  function readPending() {
    try {
      var raw = sessionStorage.getItem(PENDING_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.email) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function writePending(data) {
    try {
      sessionStorage.setItem(PENDING_KEY, JSON.stringify(data));
      if (data && data.email) {
        sessionStorage.setItem(SUCCESS_KEY + '-email', data.email);
      }
    } catch (e) {
      /* private mode / blocked storage */
    }
  }

  function clearPending() {
    try {
      sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function restorePendingIntoForm(form, pending) {
    if (!pending) return;
    var emailInput = form.querySelector(
      'input[type="email"][name="contact[email]"]'
    );
    var first = form.querySelector('input[name="contact[first_name]"]');
    var last = form.querySelector('input[name="contact[last_name]"]');
    if (emailInput && pending.email) emailInput.value = pending.email;
    if (first && pending.firstName) first.value = pending.firstName;
    if (last && pending.lastName) last.value = pending.lastName;
    applyYouAre(form, pending.youAre || []);
  }

  function getSelectedCountry(form) {
    var select = form.querySelector('[data-newsletter-country]');
    if (!select || !select.value) return null;
    var option = select.options[select.selectedIndex];
    if (!option) return null;
    return {
      iso: select.value,
      name: option.getAttribute('data-name') || option.textContent || '',
      dial: option.getAttribute('data-dial') || ''
    };
  }

  function fillCountrySelect(form) {
    var select = form.querySelector('[data-newsletter-country]');
    if (!select || select.getAttribute('data-countries-filled') === 'true') {
      return;
    }
    select.setAttribute('data-countries-filled', 'true');

    var seen = {};
    for (var i = 0; i < COUNTRIES.length; i++) {
      var iso = COUNTRIES[i][0];
      if (seen[iso]) continue;
      seen[iso] = true;
      var option = document.createElement('option');
      option.value = iso;
      option.textContent = COUNTRIES[i][1];
      option.setAttribute('data-name', COUNTRIES[i][1]);
      option.setAttribute('data-dial', COUNTRIES[i][2]);
      select.appendChild(option);
    }

    if (!select.value) {
      select.value = 'AU';
    }
    updateDialPrefix(form);
  }

  function updateDialPrefix(form) {
    var dialEl = form.querySelector('[data-newsletter-dial]');
    var phone = form.querySelector('[data-newsletter-phone]');
    var country = getSelectedCountry(form);
    if (dialEl) {
      if (country && country.dial) {
        dialEl.textContent = '+' + country.dial;
        dialEl.hidden = false;
        dialEl.removeAttribute('hidden');
      } else {
        dialEl.textContent = '';
        dialEl.hidden = true;
        dialEl.setAttribute('hidden', '');
      }
    }
    if (phone) {
      phone.placeholder = country && country.dial ? 'Mobile number' : 'Include country code';
    }
  }

  function setStepError(form, step, message) {
    var error = form.querySelector(
      '[data-newsletter-step' + step + '-error]'
    );
    if (!error) return;
    if (message) {
      error.textContent = message;
      error.hidden = false;
      error.removeAttribute('hidden');
    } else {
      error.textContent = '';
      error.hidden = true;
      error.setAttribute('hidden', '');
    }
  }

  function setPhoneError(form, message) {
    var error = form.querySelector('[data-newsletter-phone-error]');
    if (!error) return;
    if (message) {
      error.textContent = message;
      error.hidden = false;
      error.removeAttribute('hidden');
    } else {
      error.textContent = '';
      error.hidden = true;
      error.setAttribute('hidden', '');
    }
  }

  function normalizePhone(raw, dial) {
    var trimmed = (raw || '').trim();
    if (!trimmed) {
      return { ok: true, e164: '' };
    }

    // Keep digits and a single leading +
    var cleaned = trimmed.replace(/[^\d+]/g, '');
    if (cleaned.indexOf('+') > 0 || (cleaned.match(/\+/g) || []).length > 1) {
      return {
        ok: false,
        message: 'Use digits only, or start with + and your country code'
      };
    }

    var e164;
    if (cleaned.charAt(0) === '+') {
      e164 = '+' + cleaned.slice(1).replace(/\D/g, '');
    } else {
      if (!dial) {
        return {
          ok: false,
          message: 'Select a country so we can format your number'
        };
      }
      var national = cleaned.replace(/\D/g, '');
      if (national.charAt(0) === '0') {
        national = national.slice(1);
      }
      // Already typed country code without +
      if (
        national.indexOf(dial) === 0 &&
        national.length > dial.length + 6
      ) {
        e164 = '+' + national;
      } else {
        e164 = '+' + dial + national;
      }
    }

    var digits = e164.replace(/\D/g, '');
    if (digits.length < 8 || digits.length > 15) {
      return {
        ok: false,
        message: 'Enter a valid mobile number'
      };
    }

    return { ok: true, e164: e164 };
  }

  function formKey(form) {
    return form.id || getSource(form) || 'newsletter';
  }

  function shopifyAction(form) {
    return (
      form.getAttribute('data-klaviyo-action') ||
      form.getAttribute('action') ||
      window.location.pathname
    );
  }

  function neutralizeNativeSubmit(form) {
    if (!form.getAttribute('data-klaviyo-action')) {
      form.setAttribute(
        'data-klaviyo-action',
        form.getAttribute('action') || window.location.pathname
      );
    }
    // If anything bypasses preventDefault, POST lands in a hidden iframe
    // instead of reloading the coming-soon page.
    ensureSink();
    form.setAttribute('target', SINK_NAME);
  }

  function klaviyoHeaders() {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Revision: REVISION
    };
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: klaviyoHeaders(),
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Request failed: ' + res.status);
      return res;
    });
  }

  function createProfile(email, source, firstName, lastName, step, youAre) {
    var attributes = {
      email: email,
      properties: {
        signup_source: source,
        signup_completed_step: step
      }
    };

    if (firstName) attributes.first_name = firstName;
    if (lastName) attributes.last_name = lastName;
    if (youAre && youAre.length) {
      attributes.properties.you_are = youAre;
    }

    return postJson(PROFILE_ENDPOINT, {
      data: {
        type: 'profile',
        attributes: attributes
      }
    });
  }

  function subscribe(email, source, firstName, lastName, youAre) {
    var attributes = {
      email: email,
      properties: {
        signup_source: source,
        signup_completed_step: 1
      },
      subscriptions: {
        email: {
          marketing: {
            consent: 'SUBSCRIBED'
          }
        }
      }
    };

    if (firstName) attributes.first_name = firstName;
    if (lastName) attributes.last_name = lastName;
    if (youAre && youAre.length) {
      attributes.properties.you_are = youAre;
    }

    return postJson(SUBSCRIBE_ENDPOINT, {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: attributes
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: LIST_ID
            }
          }
        }
      }
    });
  }

  function trackSignup(email, source, firstName, lastName) {
    var profile = {
      email: email
    };
    if (firstName) profile.first_name = firstName;
    if (lastName) profile.last_name = lastName;

    return postJson(EVENT_ENDPOINT, {
      data: {
        type: 'event',
        attributes: {
          properties: {
            signup_source: source
          },
          unique_id: email + ':' + Date.now(),
          metric: {
            data: {
              type: 'metric',
              attributes: { name: 'Submitted Newsletter Form' }
            }
          },
          profile: {
            data: {
              type: 'profile',
              attributes: profile
            }
          }
        }
      }
    }).catch(function () {
      /* Activity log only; never fail signup on a missed event */
    });
  }

  function subscribeSms(email, phoneE164) {
    return postJson(SUBSCRIBE_ENDPOINT, {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                phone_number: phoneE164,
                subscriptions: {
                  sms: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: LIST_ID
            }
          }
        }
      }
    });
  }

  function updateProfileExtras(email, extras) {
    var properties = {
      signup_completed_step: 2
    };

    if (extras.instagram) properties.instagram = extras.instagram;
    if (extras.boardShaper) properties.preferred_board_shaper = extras.boardShaper;
    if (extras.foilBrand) properties.preferred_foil_brand = extras.foilBrand;
    if (extras.youAre && extras.youAre.length) {
      properties.you_are = extras.youAre;
    }
    if (extras.foiling && extras.foiling.length) {
      properties.you_love_foiling = extras.foiling;
    }
    if (extras.countryIso) properties.country_code = extras.countryIso;
    if (extras.aboutYou) properties.about_you = extras.aboutYou;

    var attributes = {
      email: email,
      properties: properties
    };

    if (extras.phoneE164) {
      attributes.phone_number = extras.phoneE164;
      properties.phone = extras.phoneE164;
    }

    if (extras.businessName) {
      attributes.organization = extras.businessName;
      properties.business_name = extras.businessName;
    }

    if (
      extras.address1 ||
      extras.address2 ||
      extras.city ||
      extras.region ||
      extras.zip ||
      extras.countryName
    ) {
      attributes.location = {};
      if (extras.address1) attributes.location.address1 = extras.address1;
      if (extras.address2) attributes.location.address2 = extras.address2;
      if (extras.city) attributes.location.city = extras.city;
      if (extras.region) attributes.location.region = extras.region;
      if (extras.zip) attributes.location.zip = extras.zip;
      if (extras.countryName) attributes.location.country = extras.countryName;
    }

    var body = {
      data: {
        type: 'profile',
        attributes: attributes
      }
    };

    return postJson(PROFILE_ENDPOINT, body);
  }

  function withTimeout(promise, ms) {
    return Promise.race([
      promise,
      new Promise(function (resolve) {
        setTimeout(resolve, ms);
      })
    ]);
  }

  function submitShopify(form) {
    var action = shopifyAction(form);
    var method = (form.getAttribute('method') || 'post').toUpperCase();
    if (method === 'DIALOG') method = 'POST';
    return fetch(action, {
      method: method,
      body: new FormData(form),
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      redirect: 'follow'
    }).catch(function () {
      /* Prefer showing success even if Shopify response fails to parse */
    });
  }

  function showSuccess(form) {
    var success = form.querySelector(
      '[data-newsletter-success], .newsletter__success, .footer__newsletter-success'
    );
    if (!success) {
      success = document.createElement('p');
      success.className = form.querySelector('.footer__newsletter')
        ? 'footer__newsletter-success'
        : 'newsletter__success';
      success.setAttribute('data-newsletter-success', '');
      success.textContent = 'Thanks for subscribing';
      form.appendChild(success);
    }
    success.hidden = false;
    success.removeAttribute('hidden');
    success.style.display = 'block';

    try {
      sessionStorage.setItem(SUCCESS_KEY, formKey(form));
      if (isMultiStep(form)) {
        sessionStorage.setItem(STEP_KEY, 'done:' + formKey(form));
      }
    } catch (e) {
      /* private mode / blocked storage */
    }
  }

  function setHeadingStep(form, step) {
    var root = form.closest('.newsletter-section__content');
    if (!root) return;
    var headings = root.querySelectorAll('[data-newsletter-heading]');
    var stepValue = String(step);
    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i];
      var isActive = heading.getAttribute('data-newsletter-heading') === stepValue;
      heading.hidden = !isActive;
      if (isActive) {
        heading.removeAttribute('hidden');
        heading.style.display = '';
      } else {
        heading.setAttribute('hidden', '');
        heading.style.display = 'none';
      }
    }
  }

  function hideSuccess(form) {
    var success = form.querySelector(
      '[data-newsletter-success], .newsletter__success, .footer__newsletter-success'
    );
    if (!success) return;
    success.hidden = true;
    success.setAttribute('hidden', '');
    success.style.display = 'none';
  }

  // Only call after a click — on page load the browser is already at the top.
  function scrollFormIntoView(form) {
    if (!form || typeof form.scrollIntoView !== 'function') return;
    var reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      form.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    } catch (e) {
      form.scrollIntoView();
    }
  }

  function isStep2Preview() {
    try {
      return (
        new URLSearchParams(window.location.search).get('step') === 'test'
      );
    } catch (e) {
      return false;
    }
  }

  function showStep2(form, scroll, preview) {
    var step1 = form.querySelector('[data-newsletter-step="1"]');
    var step2 = form.querySelector('[data-newsletter-step="2"]');
    if (step1) {
      step1.hidden = true;
      step1.setAttribute('hidden', '');
    }
    if (step2) {
      step2.hidden = false;
      step2.removeAttribute('hidden');
    }
    setHeadingStep(form, 2);
    // Step 2 uses the yellow intro above the fields — keep the
    // under-form confirmation hidden until the flow is finished.
    hideSuccess(form);

    if (!preview) {
      try {
        sessionStorage.setItem(STEP_KEY, '2:' + formKey(form));
        sessionStorage.removeItem(SUCCESS_KEY);
        sessionStorage.setItem(
          SUCCESS_KEY + '-email',
          getEmail(form) || sessionStorage.getItem(SUCCESS_KEY + '-email') || ''
        );
      } catch (e) {
        /* ignore */
      }
    }
    toggleConditionalFields(form);
    if (scroll) scrollFormIntoView(form);
  }

  function finishMultiStep(form, scroll) {
    var step1 = form.querySelector('[data-newsletter-step="1"]');
    var step2 = form.querySelector('[data-newsletter-step="2"]');
    if (step1) {
      step1.hidden = true;
      step1.setAttribute('hidden', '');
    }
    if (step2) {
      step2.hidden = true;
      step2.setAttribute('hidden', '');
    }
    setHeadingStep(form, 2);
    showSuccess(form);
    clearPending();
    if (scroll) scrollFormIntoView(form);
  }

  function continueAfterStep1(form, email, firstName, lastName, youAre) {
    writePending({
      email: email,
      firstName: firstName,
      lastName: lastName,
      youAre: youAre || []
    });

    if (getStep2Destination(form) === 'dedicated_page') {
      var url = getStep2Url(form) || DEFAULT_STEP2_URL;
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      window.location.href = url + sep + 'step=2';
      return;
    }

    showStep2(form, true);
  }

  function restoreSuccess(form) {
    try {
      var key = formKey(form);
      if (isMultiStep(form)) {
        if (isStep2Preview()) {
          showStep2(form, false, true);
          return;
        }
        if (getStep2Destination(form) === 'dedicated_page') {
          hideSuccess(form);
          return;
        }
        var step = sessionStorage.getItem(STEP_KEY) || '';
        if (step === 'done:' + key) {
          finishMultiStep(form);
          return;
        }
        var pending = readPending();
        if (pending) {
          restorePendingIntoForm(form, pending);
          showStep2(form);
          return;
        }
        if (step === '2:' + key) {
          var savedEmail = sessionStorage.getItem(SUCCESS_KEY + '-email');
          var emailInput = form.querySelector(
            'input[type="email"][name="contact[email]"]'
          );
          if (savedEmail && emailInput && !emailInput.value) {
            emailInput.value = savedEmail;
          }
          showStep2(form);
          return;
        }
        // Do not revive a stale under-form thank-you from older single-step tests
        hideSuccess(form);
        return;
      }
      if (sessionStorage.getItem(SUCCESS_KEY) === key) {
        showSuccess(form);
      }
    } catch (e) {
      /* ignore */
    }
  }

  function handleSingleStepSubmit(form) {
    if (form.getAttribute('data-klaviyo-submitting') === 'true') return;

    var email = getEmail(form);
    if (!email) return;

    form.setAttribute('data-klaviyo-submitting', 'true');

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    var source = getSource(form);
    withTimeout(
      subscribe(email, source)
        .then(function () {
          return trackSignup(email, source);
        })
        .catch(function () {
          /* Never block Shopify signup on Klaviyo errors */
        }),
      TIMEOUT_MS
    )
      .then(function () {
        return withTimeout(submitShopify(form), TIMEOUT_MS);
      })
      .then(function () {
        showSuccess(form);
        var input = form.querySelector(
          'input[type="email"][name="contact[email]"]'
        );
        if (input) input.value = '';
      })
      .finally(function () {
        form.removeAttribute('data-klaviyo-submitting');
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function handleStep1Submit(form) {
    if (form.getAttribute('data-klaviyo-submitting') === 'true') return;

    var email = getEmail(form);
    var firstName = getTextValue(form, 'input[name="contact[first_name]"]');
    var lastName = getTextValue(form, 'input[name="contact[last_name]"]');
    var youAre = getCheckedValues(form, '[data-newsletter-you-are]');
    var optIn = form.querySelector('[data-newsletter-marketing-optin]');
    if (!email || !firstName || !lastName) return;
    if (!optIn || !optIn.checked) {
      if (optIn && typeof optIn.reportValidity === 'function') {
        optIn.reportValidity();
      }
      return;
    }

    form.setAttribute('data-klaviyo-submitting', 'true');

    var submitBtn = form.querySelector('[data-newsletter-step1-submit]');
    if (submitBtn) submitBtn.disabled = true;
    setStepError(form, 1, '');

    var source = getSource(form);
    createProfile(email, source, firstName, lastName, 1, youAre)
      .catch(function () {
        /* Existing profiles error on create; subscribe still upserts */
      })
      .then(function () {
        return subscribe(email, source, firstName, lastName, youAre);
      })
      .then(function () {
        return trackSignup(email, source, firstName, lastName);
      })
      .then(function () {
        continueAfterStep1(form, email, firstName, lastName, youAre);
      })
      .catch(function () {
        setStepError(
          form,
          1,
          'Could not save your signup. Check your connection and try again.'
        );
      })
      .finally(function () {
        form.removeAttribute('data-klaviyo-submitting');
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function collectStep2Extras(form) {
    var country = getSelectedCountry(form);
    var rawPhone = getTextValue(form, '[data-newsletter-phone]');
    var phoneResult = normalizePhone(rawPhone, country && country.dial);
    var youAre = getCheckedValues(form, '[data-newsletter-you-are]');
    var addressVisible = needsAddress(youAre);
    var shaperVisible = !isShaper(youAre);

    return {
      phoneRaw: rawPhone,
      phoneResult: phoneResult,
      phoneE164: phoneResult.ok ? phoneResult.e164 : '',
      countryIso: country ? country.iso : '',
      countryName: country ? country.name : '',
      instagram: getTextValue(form, '[data-newsletter-instagram]'),
      boardShaper: shaperVisible
        ? getTextValue(form, '[data-newsletter-board-shaper]')
        : '',
      foilBrand: getTextValue(form, '[data-newsletter-foil-brand]'),
      youAre: youAre,
      foiling: getCheckedValues(form, '[data-newsletter-foiling]'),
      businessName: addressVisible
        ? getTextValue(form, '[data-newsletter-business-name]')
        : '',
      address1: addressVisible
        ? getTextValue(form, '[data-newsletter-address1]')
        : '',
      address2: addressVisible
        ? getTextValue(form, '[data-newsletter-address2]')
        : '',
      city: addressVisible ? getTextValue(form, '[data-newsletter-city]') : '',
      region: addressVisible
        ? getTextValue(form, '[data-newsletter-region]')
        : '',
      zip: addressVisible ? getTextValue(form, '[data-newsletter-zip]') : '',
      aboutYou: getTextValue(form, '[data-newsletter-about]')
    };
  }

  function handleStep2Submit(form) {
    if (form.getAttribute('data-klaviyo-submitting') === 'true') return;

    var email = getEmail(form);
    try {
      if (!email) {
        email = sessionStorage.getItem(SUCCESS_KEY + '-email') || '';
      }
    } catch (e) {
      /* ignore */
    }
    if (!email) {
      finishMultiStep(form, true);
      return;
    }

    var extras = collectStep2Extras(form);
    if (!extras.phoneResult.ok) {
      setPhoneError(form, extras.phoneResult.message);
      var phoneInput = form.querySelector('[data-newsletter-phone]');
      if (phoneInput) phoneInput.focus();
      return;
    }
    setPhoneError(form, '');

    form.setAttribute('data-klaviyo-submitting', 'true');
    var submitBtn = form.querySelector('[data-newsletter-step2-submit]');
    if (submitBtn) submitBtn.disabled = true;
    setStepError(form, 2, '');

    updateProfileExtras(email, extras)
      .then(function () {
        if (!extras.phoneE164) return;
        return subscribeSms(email, extras.phoneE164).catch(function () {
          /* Keep the saved number even if SMS consent fails */
        });
      })
      .then(function () {
        finishMultiStep(form, true);
      })
      .catch(function () {
        setStepError(
          form,
          2,
          'Could not save those details. Try again, or skip for now.'
        );
      })
      .finally(function () {
        form.removeAttribute('data-klaviyo-submitting');
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function handleStep2Skip(form) {
    clearPending();
    finishMultiStep(form, true);
  }

  function handleSubmit(form) {
    if (isMultiStep(form)) {
      handleStep1Submit(form);
      return;
    }
    handleSingleStepSubmit(form);
  }

  function bindMultiStepControls(form) {
    if (!isMultiStep(form)) return;
    if (form.getAttribute('data-klaviyo-multi-bound') === 'true') return;
    form.setAttribute('data-klaviyo-multi-bound', 'true');

    fillCountrySelect(form);
    toggleConditionalFields(form);

    bindMultiselect(form);

    var youAreBoxes = form.querySelectorAll('[data-newsletter-you-are]');
    for (var i = 0; i < youAreBoxes.length; i++) {
      youAreBoxes[i].addEventListener('change', function () {
        toggleConditionalFields(form);
        updateMultiselectLabel(form);
      });
    }

    var countrySelect = form.querySelector('[data-newsletter-country]');
    if (countrySelect) {
      countrySelect.addEventListener('change', function () {
        updateDialPrefix(form);
        setPhoneError(form, '');
      });
    }

    var phoneInput = form.querySelector('[data-newsletter-phone]');
    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        setPhoneError(form, '');
      });
    }

    var step2Submit = form.querySelector('[data-newsletter-step2-submit]');
    var step2Skip = form.querySelector('[data-newsletter-step2-skip]');

    if (step2Submit) {
      step2Submit.addEventListener('click', function () {
        handleStep2Submit(form);
      });
    }
    if (step2Skip) {
      step2Skip.addEventListener('click', function () {
        handleStep2Skip(form);
      });
    }
  }

  function prepareForm(form) {
    if (!form) return;
    neutralizeNativeSubmit(form);
    bindMultiStepControls(form);
    if (form.getAttribute('data-klaviyo-prepared') === 'true') return;
    form.setAttribute('data-klaviyo-prepared', 'true');
    restoreSuccess(form);
  }

  function init() {
    ensureSink();
    var forms = document.querySelectorAll('form.js-klaviyo-newsletter');
    for (var i = 0; i < forms.length; i++) {
      prepareForm(forms[i]);
    }
  }

  // Single capture-phase gate on document — always cancels navigation before
  // any bubble handlers, and works for late-rendered sections too.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (
        !form ||
        form.tagName !== 'FORM' ||
        !form.classList ||
        !form.classList.contains('js-klaviyo-newsletter')
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      prepareForm(form);
      handleSubmit(form);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('click', function (event) {
    var root =
      event.target && event.target.closest
        ? event.target.closest('[data-newsletter-multiselect]')
        : null;
    closeOpenMultiselects(root);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openRoots = document.querySelectorAll('[data-newsletter-multiselect].is-open');
    for (var i = 0; i < openRoots.length; i++) {
      var toggle = openRoots[i].querySelector('[data-newsletter-multiselect-toggle]');
      var form = openRoots[i].closest('form');
      if (form) setMultiselectOpen(form, false);
      if (toggle) toggle.focus();
    }
  });
})();
